import {
  DelistingRecommendationRejectionReason,
  DelistingRecommendationsGroupedByProduct,
  Vendor,
} from 'common/api-types/recommendations';

export function getRecommendationItems(
  ids: string[],
  items: DelistingRecommendationsGroupedByProduct[],
) {
  return items
    .flatMap(({ venueItems }) => venueItems.filter((venueItem) => ids.includes(venueItem.id)))
    .map(({ id, version }) => ({ id, version }));
}

export const extractVendorSummary = (vendors: Vendor[]) => {
  const vendorsMap = [
    ...new Map(
      vendors.map((vendor) => [vendor.id, { vendorName: vendor.name, vendorId: vendor.id }]),
    ).values(),
  ];

  const primaryVendor = vendorsMap[0];
  const otherVendorsCount = vendorsMap.length - 1;

  return { primaryVendor, otherVendorsCount };
};

export const downloadableReasons: DelistingRecommendationRejectionReason[] = [
  'STRATEGIC_IMPORTANCE_ASSORTMENT_DIFFERENTIATION',
  'STRATEGIC_IMPORTANCE_NO_ALTERNATIVE_PRODUCTS',
  'UNCOMPETITIVE_COST_PRICE',
  'UNCOMPETITIVE_SALES_PRICE',
  'PRODUCT_HARD_TO_FIND',
];

export const reasons: DelistingRecommendationRejectionReason[] = [
  ...downloadableReasons,
  'VENDOR_CONTRACT_BLOCKER',
  'LOGISTIC_REASONS',
  'SEASONAL_PRODUCT',
  'OTHER',
];
